import { PropTypes } from "prop-types";

//utils
import apiService from "../../../config/api-config";
import { deleteCookies } from "../../../serviceWorker";
import Menu from "../Menu";
import { removeLocalStorageFlag } from "../../../utils/common";
import { useAppContext } from "../../../context/AppContext";

const ManagerTab = (props) => {
    const { showAppSpinner, hideAppSpinner } = useAppContext();

    const vmanageOnClick = async (event, redirectUrl) => {
        try {
            showAppSpinner();
            event.preventDefault();
            let res = await apiService.logout();
            deleteCookies();
            removeLocalStorageFlag("overlays");
            if (res) {
                window.location.href = redirectUrl;
                setTimeout(() => {
                    hideAppSpinner();
                }, 3000);
            }
        } catch (err) {
            console.log("Error while calling logout", err);
        }
    };

    return (
        <Menu
            collapsed
            isSingleMenuItem={true}
            navItem={props.navItem}
            onClick={e => {
                vmanageOnClick(e, props.redirectUrl);
            }}
        />
    )
}

ManagerTab.propTypes = {
    navItem: PropTypes.object,
    redirectUrl: PropTypes.string
};
export default ManagerTab;